"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSelectTenant = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../../auth/index");
exports.ZSelectTenant = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(index_1.Background, null,
        react_1.default.createElement(index_1.ModalWrapper, null,
            react_1.default.createElement(index_1.SelectTenant, Object.assign({}, props)))),
    react_1.default.createElement(index_1.Footer, null)));
//# sourceMappingURL=ZSelectTenant.js.map